import { FooterLink } from './types';
import localFooterLinks from './footer-links.json';
export const defaultFooterLinks: FooterLink[] = localFooterLinks as FooterLink[];
